<template>
  <div class="md:w-12/12 flex alert alert-danger p-4">
    <div class="w-[60px] h-[60px] mr-6 hide-mobile">
      <i-circle-exclamation
        filled
        :font-controlled="false"
      />
    </div>
    <div class="flex justify-center align-center items-center">
      <p class="mb-0">
        {{ $t('500description') }}
      </p>
    </div>
  </div>
</template>